<template>
  <div class="taux-emission-create page-layout">
    <PageHeader
      title="Ajouter une taxe sur vehicule société (émissions de CO₂)"
      :has-back="true"
      @back="goBack"
    />

    <md-card class="meep-form">
      <md-card-content>
        <div class="meep-form-column meep-form-single-column">
          <div class="meep-input">
            <md-field :class="{ 'md-invalid': errors.has('emission_min') }">
              <label>Emission min *</label>
              <md-input
                v-model="form.emission_min"
                v-validate="'required|decimal'"
                name="emission_min"
                type="emission_min"
              >
              </md-input>
              <span class="md-error" v-show="errors.has('emission_min')">
                {{ errors.first("emission_min") }}
              </span>
            </md-field>
          </div>

          <div class="meep-input">
            <md-field :class="{ 'md-invalid': errors.has('emission_max') }">
              <label>Emission max *</label>
              <md-input
                v-model="form.emission_max"
                v-validate="'decimal'"
                name="emission_max"
                type="emission_max"
              >
              </md-input>
              <span class="md-error" v-show="errors.has('emission_max')">
                {{ errors.first("emission_max") }}
              </span>
            </md-field>
          </div>

          <div class="meep-input">
            <md-field :class="{ 'md-invalid': errors.has('coef') }">
              <label>Coef *</label>
              <md-input
                v-model="form.coef"
                v-validate="'required|decimal'"
                name="coef"
                type="text"
              >
              </md-input>
              <span class="md-error" v-show="errors.has('coef')">
                {{ errors.first("coef") }}
              </span>
            </md-field>
          </div>

          <div class="md-layout md-alignment-center-right">
            <md-button
              class="md-raised md-primary"
              @click.native="createEmisssion"
            >
              Ajouter une taxe
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import calculatorsModel from "../../../../model/calculators";
import PageHeader from "@/components/PageHeader";

export default {
  components: { PageHeader },
  data() {
    return {
      isDebug: false,
      form: {
        emission_min: "",
        emission_max: "",
        coef: "",
      },
    };
  },
  methods: {
    goBack() {
      window.history.back();
    },
    createEmisssion() {
      this.$validator.validateAll().then(result => {
        if (result) {
          calculatorsModel
            .createEmission(this.form)
            .then(() => {
              this.$toasted.global.AppSucces({
                message: "L'emission a bien été enregistré",
              });

              this.$router.push(
                "/admin/calculators/taxe-vehicule-societe-emission/list"
              );
            })
            .catch(err => {
              this.$toasted.global.AppError({
                message: err.msg,
              });
            });
        } else {
          this.$toasted.global.AppInfo({
            message: "Vous devez remplir les champs manquants",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.taux-emission-create {
  .debug-log {
    max-height: 360px;
    overflow-y: scroll;
  }

  .md-card {
    margin-top: 32px;
    margin-bottom: 32px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
